import { ButtonView, Plugin, viewToModelPositionOutsideModelElement } from 'ckeditor5';
import { InsertPlaceholderCommand } from './InsertPlaceholderCommand';
import { INSERT_PLACEHOLDER_COMMAND, REMOVE_PLACEHOLDER_COMMAND, RENAME_PLACEHOLDER_REF_COMMAND, RemovePlaceholderCommand, SET_PLACEHOLDER_REF_COMMAND, } from './RemovePlaceholderCommand';
import { RenamePlaceholderRefCommand } from './RenamePlaceholderRefCommand';
import { SetPlaceholderRefCommand } from './SetPlaceholderRefCommand';
import { PlaceholderStore } from './store';
/**
 * Registers the placeholder commands, the "create placeholder" toolbar button, and the position
 * mapper that keeps the caret from wandering inside a placeholder widget.
 *
 * There is no longer a dropdown of placeholders already in the document — picking a question is the
 * job of the editor opened by `placeholders.onEditRequest`, which knows the whole question list
 * rather than only the refs that happen to be used already.
 */
export class PlaceholderToolbar extends Plugin {
    static get pluginName() {
        return 'PlaceholderToolbar';
    }
    static get requires() {
        return [PlaceholderStore];
    }
    init() {
        const { editor } = this;
        // Commands are registered even in readonly mode: they are the only way to mutate placeholders,
        // and a host app may need them independently of the authoring UI.
        editor.commands.add(INSERT_PLACEHOLDER_COMMAND, new InsertPlaceholderCommand(editor));
        editor.commands.add(SET_PLACEHOLDER_REF_COMMAND, new SetPlaceholderRefCommand(editor));
        editor.commands.add(RENAME_PLACEHOLDER_REF_COMMAND, new RenamePlaceholderRefCommand(editor));
        editor.commands.add(REMOVE_PLACEHOLDER_COMMAND, new RemovePlaceholderCommand(editor));
        if (editor.config.get('placeholders.readonly')) {
            return;
        }
        this.registerNewPlaceholderButton();
        editor.editing.mapper.on('viewToModelPosition', viewToModelPositionOutsideModelElement(editor.model, (viewElement) => viewElement.hasClass('placeholder')));
    }
    registerNewPlaceholderButton() {
        const { editor } = this;
        editor.ui.componentFactory.add('placeholderCreate', () => {
            const button = new ButtonView();
            button.set({
                label: 'Create placeholder',
                withText: true,
                class: 'pleditor-toolbar-fa-icon-button',
            });
            button.on('execute', () => {
                var _a;
                // Insert unconfigured, then ask the app to configure it. Nothing invents a ref.
                const instanceId = (_a = editor.commands.get(INSERT_PLACEHOLDER_COMMAND)) === null || _a === void 0 ? void 0 : _a.execute();
                const onEditRequest = editor.config.get('placeholders.onEditRequest');
                if (instanceId && onEditRequest) {
                    const request = { instanceId, ref: '', anchor: null, isNew: true };
                    onEditRequest(request);
                }
            });
            return button;
        });
    }
}
